import React from 'react';
import { BookingConfig } from '../../types/booking';

interface FormFieldProps {
  label: string;
  error?: string;
  required?: boolean;
  children: React.ReactNode;
  config: BookingConfig;
}

export const FormField: React.FC<FormFieldProps> = ({ 
  label, 
  error, 
  required = false, 
  children, 
  config 
}) => {
  const { theme, darkMode } = config;

  return (
    <div className="space-y-2">
      <label className={`block text-sm font-medium ${
        darkMode ? 'text-gray-200' : 'text-gray-700'
      }`}>
        {label}
        {required && <span style={{ color: theme.error }} className="ml-1">*</span>}
      </label>
      {children}
      {error && (
        <p 
          className="text-sm flex items-center gap-1"
          style={{ color: theme.error }}
          role="alert"
          aria-live="polite"
        >
          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
          </svg>
          {error}
        </p>
      )}
    </div>
  );
};